module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/ashley-correia-c68675c51e6514e59e85223834811063.jpg";